import React from 'react';

export const useResizeObserver = (onResize: ResizeObserverCallback) => {
  const roRef = React.useRef<ResizeObserver | null>(null);

  const attachResizeObserver = React.useCallback(
    (element: HTMLElement) => {
      const resizeObserver = new ResizeObserver(onResize);
      resizeObserver.observe(element);
      roRef.current = resizeObserver;
    },
    [onResize],
  );

  const detachResizeObserver = React.useCallback(() => {
    roRef.current?.disconnect();
  }, []);

  const refCb = React.useCallback(
    (element: HTMLElement | null) => {
      if (element) {
        attachResizeObserver(element);
      } else {
        detachResizeObserver();
      }
    },
    [attachResizeObserver, detachResizeObserver],
  );

  return refCb;
};
